const DATE_INPUT_MAX_LENGTH = 10;
const TIME_INPUT_LENGTH_FOR_24_HOUR_FORMAT = 8;
const TIME_INPUT_LENGTH_FOR_12_HOUR_FORMAT = 11;
const TIME_INPUT_LENGTH = 8;

const LENGTH_UPTO_YEAR_END = 4;
const LENGTH_UPTO_MONTH_END = 7;

const LENGTH_UPTO_HOUR_END = 2;
const LENGTH_UPTO_MINUTES_START = 3;
const LENGTH_UPTO_MINUTES_END = 5;
const LENGTH_UPTO_SECONDS_START = 6;
const LENGTH_UPTO_PERIOD_START = 9;
const LENGTH_UPTO_PERIOD_END = 11;

const TWELVE_HOURS = 12;

const ZERO_INDEX = 0;
const INDEX_ONE = 1;

const TWELVE_HOUR_PERIOD_REGEX = /^ $|^ [AP]$|^ [AP]M$/;
const NUMBERS_HYPHEN_REGEX = /^[0-9-]+$/;
const NUMBERS_SEMICOLON_REGEX = /^[0-9:]+$/;
const TWELVE_HOUR_TIME_CHARACTERS_REGEX = /^[0-9:APMapm\s]+$/;
const NUMBERS_HYPHEN_PLUS_E_REGEX = /^[eE\+\-]/;
const SINGLE_DIGIT_REGEX = /^[0-9]{1}$/;

const TWELVE_HOUR_FORMAT = 'YYYY-MM-DD hh:mm:ss A';
const TWENTY_FOUR_HOURS_FORMAT = 'YYYY-MM-DD HH:mm:ss';
const DATE_FORMAT = 'YYYY-MM-DD';

const ONE_HOUR_IN_MILLISECONDS = 3600000;
const TWENTY_FOUR_HOURS = 24;
const SEVEN_DAYS = 7;
const THIRTY_DAYS = 30;
const ONE_SECOND_IN_MS = 1000;

const BACKSPACE_KEY_CODE = 8;
const TAB_KEY_CODE = 9;
const ARROW_LEFT_KEY_CODE = 37;
const ARROW_RIGHT_KEY_CODE = 39;
const DELETE_KEY_CODE = 46;
const ONE_MINUTE_IN_MS = 60000;
const E_KEY_CODE = 69;

export {
  ARROW_LEFT_KEY_CODE,
  ARROW_RIGHT_KEY_CODE,
  BACKSPACE_KEY_CODE,
  DATE_FORMAT,
  DATE_INPUT_MAX_LENGTH,
  DELETE_KEY_CODE,
  INDEX_ONE,
  LENGTH_UPTO_HOUR_END,
  LENGTH_UPTO_MINUTES_END,
  LENGTH_UPTO_MINUTES_START,
  LENGTH_UPTO_MONTH_END,
  LENGTH_UPTO_PERIOD_END,
  LENGTH_UPTO_PERIOD_START,
  LENGTH_UPTO_SECONDS_START,
  LENGTH_UPTO_YEAR_END,
  NUMBERS_HYPHEN_REGEX,
  NUMBERS_SEMICOLON_REGEX,
  NUMBERS_HYPHEN_PLUS_E_REGEX,
  ONE_HOUR_IN_MILLISECONDS,
  ONE_MINUTE_IN_MS,
  ONE_SECOND_IN_MS,
  SEVEN_DAYS,
  SINGLE_DIGIT_REGEX,
  THIRTY_DAYS,
  TIME_INPUT_LENGTH,
  TIME_INPUT_LENGTH_FOR_12_HOUR_FORMAT,
  TIME_INPUT_LENGTH_FOR_24_HOUR_FORMAT,
  TWELVE_HOURS,
  TWELVE_HOUR_FORMAT,
  TWELVE_HOUR_PERIOD_REGEX,
  TWELVE_HOUR_TIME_CHARACTERS_REGEX,
  TWENTY_FOUR_HOURS,
  TWENTY_FOUR_HOURS_FORMAT,
  ZERO_INDEX,
  TAB_KEY_CODE,
  E_KEY_CODE,
};
